// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"b28f601f","117":"ea1331ba","265":"217434e9","336":"fb98c17c"}[chunkId] + ".js";
};